import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import emailjs from "@emailjs/browser";
import toastr from "toastr";
import BackToTop from "./BackToTop";

const Enquiry = () => {
  const [images, setImages] = useState([]);
  const [imageURLs, setImageURls] = useState([]);
  const showToast = () => {
    toastr.success("This is a success message!");
  };

  useEffect(() => {
    if (images.length < 1) return;
    const newImageURLs = [];
    images.forEach((image) => newImageURLs.push(URL.createObjectURL(image)));
    setImageURls(newImageURLs);
  }, [images]);

  function onImaeChange(e) {
    setImages([...e.target.files]);
  }

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_uai4d7o",
        "template_kzd68jv",
        form.current,
        "p3eBhF9vOXms-YLN7"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  //contact number validation
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isValid, setIsValid] = useState(true);

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);

    // Regular expression for a valid phone number
    const phoneRegex = /^\d{10}$/;

    // Check if the entered phone number matches the regex
    setIsValid(phoneRegex.test(value));
  };

  const handleInputBlur = () => {
    // Reset validation when user clicks on another input field
    setIsValid(true);
  };

  return (
    <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden">
      <ol
        className="flex items-center whitespace-nowrap min-w-0 p-2 "
        aria-label="Breadcrumb"
      >
        <li className="text-sm">
          <NavLink to={"/"}>
            {" "}
            <a
              className="flex items-center text-gray-500 hover:text-blue-600"
              href="#"
            >
              <svg
                className="flex-shrink-0 mr-3 h-4 w-4 text-gray-600 dark:text-gray-600"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                />
                <path
                  fill-rule="evenodd"
                  d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                />
              </svg>
              Home
              <svg
                className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </a>{" "}
          </NavLink>
        </li>
        <NavLink to={"/enquiry"}>
          {" "}
          <li className="text-sm">
            <a
              className="flex items-center text-gray-500 hover:text-blue-600"
              href="#"
            >
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAaNJREFUSEu11U+IjVEYx/HPCAv5m4WkbCQls7GxYIGVhVjQYD2TLITZkN2wkKIoSbITpWQhWViMiGQx09TY2tiIhKnJQsL01HnrzPFec+977z2bU+97nt/3PM95zu8M6PMY6LO+hQCLcQy7sRlbsQTv8B5vsREH0/+vOIHH1cb/BxjBRaxvkOU+PIu4OsAK3MOBBsJVyBS2twI8wf5MfAZXMYkJfGkDPIuVdYDTuJ4JPMUwPmff/rYBeIOdJSAO70NW8xCvMon5AjZhVRuAs7hSAo7gQQqObtiGTziHy22I5ktO4UYJuJVaLL5HmUaxB887FI/lN3GyBLzCriQ2hIcYx94GgJfp7sxr0x9YlsQ24CO+Y3UDwDesLTOI1lreQKwuJFp7TQl4XbVWDyC1JbqN4z0Qb3nIZ3CtR4DDeFSW6Dwu9QAQLrsFf0pAWO+OLgFhI9HWLyqd3E1/YmmXgLCTsVwjB0xjsAtAeE940LyRA8LQwqo7HZVf3a0LLB+cQ8lH1iWju5Pmo+mOLEoiv1Od76fH6VerXS30JneazT/r+w6YA8hxRxmmGA9mAAAAAElFTkSuQmCC" />
              &nbsp; Enquiry
            </a>
          </li>{" "}
        </NavLink>
      </ol>
      {/* <!-- Comment Form --> */}
      <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto lg:-mt-10">
        <div className="mx-auto max-w-2xl">
          <div className="text-center">
            <h2 className="text-xl text-gray-800 font-bold sm:text-3xl dark:text-white">
              Enquiry
            </h2>
          </div>

          {/* <!-- Card --> */}

          <div
            id="registration-form"
            className="mt-5 p-4 relative z-10 bg-white border rounded-xl sm:mt-10 md:p-10 dark:bg-gray-800 dark:border-gray-700"
          >
            <form action="https://formspree.io/f/xqkvjrdl" method="POST">
              <div className="mb-4 sm:mb-8">
                <label
                  for=""
                  className="block mb-2 text-sm font-medium dark:text-white"
                >
                  Full name
                </label>
                <input
                  type="text"
                  id="from_name"
                  name="from_name"
                  className="py-3 px-4 block w-full border border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 sm:p-4 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 transition ease-in-out delay-100 hover:-translate-y-1 hover:scale-110 duration-300"
                  placeholder="Full name"
                  required
                />
              </div>

              <div className="mb-4 sm:mb-8">
                <label
                  for=""
                  className="block mb-2 text-sm font-medium dark:text-white"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="from_email"
                  name="from_email"
                  className="py-3 px-4 block w-full border border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 sm:p-4 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 transition ease-in-out delay-100 hover:-translate-y-1 hover:scale-110 duration-300"
                  placeholder="e-mail"
                  required
                />
              </div>

              <div className="mb-4 sm:mb-8">
                <label
                  htmlFor=""
                  className="block mb-2 text-sm font-medium dark:text-white"
                >
                  Favorite idol
                </label>
                <select
                  name="fav_idol"
                  id="fav_idol"
                  className="border border-gray-200 rounded-md text-md w-full h-12 focus:border-blue-500 focus:ring-blue-500  dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 transition ease-in-out delay-100 hover:-translate-y-1 hover:scale-110 duration-300"
                >
                  <option value="" className="font-bold">
                    RM
                  </option>
                  <option value="" className="font-bold">
                    Jin
                  </option>
                  <option value="" className="font-bold">
                    Suga
                  </option>
                  <option value="" className="font-bold">
                    J-Hope
                  </option>
                  <option value="" className="font-bold">
                    Jimin
                  </option>
                  <option value="" className="font-bold">
                    V
                  </option>
                  <option value="" className="font-bold">
                    JungKook
                  </option>
                </select>
              </div>
              <div className="mb-4 sm:mb-8">
                <label
                  for=""
                  className="block mb-2 text-sm font-medium dark:text-white"
                >
                  Upload Image
                </label>
                <input
                  type="file"
                  id="upload_image"
                  name="upload_image"
                  multiple
                  accept="image/*"
                  onChange={onImaeChange}
                  className="py-3 px-4 block w-full border border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 sm:p-4 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Upload Image"
                />
                {imageURLs.map((imageSrc) => (
                  <img
                    src={imageSrc}
                    className="h-72 w-60 p-2 border-2 border-blue-500 rounded-xl mt-1 lg:"
                  />
                ))}
              </div>

              <div className="mb-4 sm:mb-8">
                <label
                  for="contact_number"
                  className="block mb-2 text-sm font-medium dark:text-white"
                >
                  Contact Number
                </label>
                <input
                  type="number"
                  id="contact_number"
                  name="contact_number"
                  maxLength="10"
                  value={phoneNumber}
                  onChange={handlePhoneNumberChange}
                  onBlur={handleInputBlur}
                  className="py-3 px-4 block w-full border border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 sm:p-4 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 transition ease-in-out delay-100 hover:-translate-y-1 hover:scale-110 duration-300"
                  placeholder="Contact Number"
                  required
                />
                {!isValid && <p style={{ color: 'red' }}>Please enter your 10-Digit phone number.</p>}
              </div>

              <div>
                <label
                  for=""
                  className="block mb-2 text-sm font-medium dark:text-white"
                >
                  Comment
                </label>
                <div className="mt-1">
                  <textarea
                    id="comments"
                    name="comments"
                    rows="3"
                    className="py-3 px-4 block w-full border border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 sm:p-4 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 transition ease-in-out delay-100 hover:-translate-y-1 hover:scale-110 duration-300"
                    placeholder="Leave your comment here..."
                  ></textarea>
                </div>
              </div>

              <div className="mt-6 grid">
                <button
                  type="submit"
                  className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all dark:focus:ring-offset-gray-800  ease-in-out delay-150 hover:-translate-y-1 hover:scale-110  duration-300"
                  onClick={showToast}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <!-- End Comment Form --> */}
      <footer>
        <div className="max-w-[85rem] py-10 px-4 sm:px-6 lg:px-8 mx-auto bg-purple-700 ">
          {/* <!-- Grid --> */}
          <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-5 text-center">
            <div>
              <div
                className="hover:scale-105 transition-transform duration-500 ease-in-out rounded-tl-3xl rounded-br-3xl w-full object-cover text-center border-2 p-1  border-purple-400 "
                data-aos="zoom-in"
              >
                <img
                  className="rounded-tl-xl rounded-br-xl border-2  border-blue-400 hover:border-purple-400  sm:w-48 sm:h-48 lg:w-60 lg:h-60 mx-auto translate-y-2 hover:scale-105 transition-transform duration-500 ease-in-out w-full object-cover"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMmiau04xpdhBmGom7KwL474Gw9b1-F5-3pQ&usqp=CAU"
                  alt="Image Description"
                />
              </div>
            </div>
            {/* <!-- End Col --> */}

            <ul className="text-center" data-aos="zoom-out-down">
              <li className="inline-block relative pr-8 last:pr-0 last-of-type:before:hidden before:absolute before:top-1/2 before:right-3 before:-translate-y-1/2 before:content-['/'] before:text-gray-300 dark:before:text-gray-600">
                <NavLink to="/aboutus">
                  {" "}
                  <a
                    className="inline-flex gap-x-2 text-sm text-white hover:text-gray-800 dark:text-gray-500 dark:hover:text-gray-200"
                    href="#"
                  >
                    About Us
                  </a>
                </NavLink>
              </li>
              <li className="inline-block relative pr-8 last:pr-0 last-of-type:before:hidden before:absolute before:top-1/2 before:right-3 before:-translate-y-1/2 before:content-['/'] before:text-gray-300 dark:before:text-gray-600">
                <NavLink to="/gallery">
                  {" "}
                  <a
                    className="inline-flex gap-x-2 text-sm text-white hover:text-gray-800 dark:text-gray-500 dark:hover:text-gray-200"
                    href="#"
                  >
                    Gallery
                  </a>{" "}
                </NavLink>
              </li>
            </ul>
            {/* <!-- End Col --> */}

            {/* <!-- Social Brands --> */}
            <div className="-ml-3 lg:ml-0">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15551.135153652767!2d77.5545749!3d12.9856763!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3df485b9a8bf%3A0xf28a75e7f8eb2569!2sOZEO%20IT%20BUSINESS%20SERVICES%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1701418727636!5m2!1sen!2sin"
                width="400"
                height="300"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="1500"
              ></iframe>
            </div>
            {/* <!-- End Social Brands --> */}
          </div>
          {/* <!-- End Grid --> */}
        </div>
      </footer>
      <BackToTop/>
    </div>
  );
};

export default Enquiry;
